import { API } from '@stoplight/elements';
import { Box } from '@stoplight/mosaic';
import React, { useContext, useEffect, useState } from 'react';
import { loadAndMergeOpenApi } from '../utils/loadAndMergeOpenApi';

import { GlobalContext } from '../context';

export const ElementsAPI: React.FC = () => {
  const { apiDescriptionUrl, layout } = useContext(GlobalContext);
  const [mergedDoc, setMergedDoc] = useState<any | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    async function run() {
      if (!apiDescriptionUrl) return;
      try {
        const doc = await loadAndMergeOpenApi(apiDescriptionUrl);
        if (!cancelled) setMergedDoc(doc);
      } catch {
        if (!cancelled) setMergedDoc(undefined);
      }
    }
    run();
    return () => {
      cancelled = true;
    };
  }, [apiDescriptionUrl]);

  // const specUrlWithProxy =
  //   apiDescriptionUrl && window.location.origin === 'https://elements-demo.stoplight.io'
  //     ? `https://stoplight.io/cors-proxy/${apiDescriptionUrl}`
  //     : apiDescriptionUrl;

  return (
    <Box flex={1} overflowY={layout !== 'stacked' ? 'hidden' : undefined}>
      <API apiDescriptionDocument={mergedDoc} router="hash" layout={layout} />
    </Box>
  );
};
